<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 物流管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>批次流向查询</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px" @keyup.enter.native="search()">
          <el-row>
            <el-col :span="6">
              <el-form-item label="批次号" prop="batchNo">
                <el-input v-model.trim="searchform.batchNo" style="width:100%" clearable placeholder="请输入批次号" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="datelist">
                <el-date-picker style="width: 100%" v-model="searchform.datelist" :clearable="false" type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search"
                v-permission="['boxcode_select']">搜索</el-button>
              <!-- <el-button v-permission="['boxcode_export']" :loading="downloadLoading" type="primary" icon="document"
                @click="handleDownload">导出Excel</el-button> -->
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>批次流向查询</h4>
          <el-divider></el-divider>
          <el-table border v-loading="listLoading" element-loading-text="拼命加载中" :data="tableData" style="width:100%;"
            id="parent">
            <el-table-column prop="batchNo" label="批次" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="outBillCode" label="出库单号" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="productCode" label="产品编码" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="productName" label="产品名称" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dealerCode" label="经销商编码" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dealerName" label="经销商名称" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="actualBatchQuantity" label="实际出库数量" min-width="100"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="scanBatchQuantity" label="扫码数量" min-width="100"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="address" label="经销商地址" min-width="100" show-overflow-tooltip></el-table-column>

            <el-table-column prop="fromWarehouseCode" label="仓库编码" min-width="100"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="fromWarehouse" label="仓库名称" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="outBillDate" label="出库日期" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="状态" min-width="100" show-overflow-tooltip></el-table-column>
          </el-table>
          <br />
          <el-pagination background @current-change="currentchange" @size-change="pagesize"
            :current-page.sync="searchform.page" :page-sizes="[10, 20, 30, 50]"
            layout="total,prev, pager, next,jumper,sizes" :total="total_count"></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { findDirection } from "@/api/physical";
import { productlist } from "@/api/base";
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    this.open();
    this.getproductlist();
    this.search()
  },
  data() {
    return {
      //基础数据
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      //导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //搜索表单数据
      channelType: [
        {
          value: 0,
          label: "配送中心"
        },
        {
          value: 1,
          label: "退货仓"
        }
      ],
      packageLevel: [
        {
          value: 1,
          label: "盒"
        },
        {
          value: 2,
          label: "箱"
        }
      ],
      searchform: {
        datelist: [],
        "batchNo": "",
        "endTime": "",
        "limit": 10,
        "page": 1,
        "startTime": ""
      },
      productloading: false,
      show: false,
      productlist: [] //产品列表下拉
    };
  },
  methods: {
    // 获取产品下拉
    getproductlist(value) {
      this.productlist = [];
      if (value !== "") {
        this.productloading = true;
        setTimeout(() => {
          this.productloading = false;
          productlist({ productName: value }).then(response => {
            this.productlist = response.data.data;
            for (var i = 0; i < this.productlist.length; i++) {
              this.productlist[i].product =
                this.productlist[i].product_code +
                "   " +
                this.productlist[i].product_name;
            }
          });
        }, 200);
      } else {
        this.productlist = [];
      }
    },
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      this.searchform.startTime = this.searchform.datelist.length ? this.searchform.datelist[0] : '';
      this.searchform.endTime = this.searchform.datelist.length ? this.searchform.datelist[1] : '';
      findDirection(obj).then(response => {
        this.tableData = response.data.list;
        this.packdate(this.tableData);
        this.currentPage = response.data.currPage;
        this.total_count = response.data.totalCount;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    // 拼装列表数据
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
        switch (obj[i].status) {
          case 0:
            obj[i].status = "未发货";
            break;
          case 1:
            obj[i].status = "已发货";
            break;
          case 2:
            obj[i].status = "已签收";
            break;
          default:
            break;
        }
      }
    },
    //搜索事件
    search() {
      this.Tabledata(this.searchform);
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.page = currPage;
      this.Tabledata(this.searchform);
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.limit = pageSize;
      this.search();
    },
    // 载入提示
    open() {
      const h = this.$createElement;

      this.$notify({
        title: "页面提示",
        message: h("i", "数据量较大，请输入搜索条件进行筛选")
      });
    },
    //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        page_index: 1,
        pageSize: this.total_count,
        batch_no: this.searchform.batch_no,
        freight_bill_code: this.searchform.freight_bill_code,
        out_bill_code: this.searchform.out_bill_code,
        qrcode: this.searchform.qrcode,
        product_code: this.searchform.product_code
      };
      findDirection(obj).then(response => {
        this.tableDataDownload = response.data.list;
        this.packdate(this.tableDataDownload);
        this.total_count = response.data.totalCount;
        this.currentPage = response.data.currPage;
        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = [
            "运单号",
            "出库单号",
            "发货仓库",
            "客户",
            "产品",
            "箱码",
            "包装级别",
            "出库批次"
          ];
          const filterVal = [
            "freight_bill_code",
            "out_bill_code",
            "from_warehouse",
            "dealer_name",
            "product",
            "qrcode",
            "packageLevel",
            "batch_no"
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}

.border {
  padding: 10px 10px;
  border-radius: 3px;
  border: 1px solid #e6ebf5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}

.handle-box {
  margin-bottom: 0px;
}

.handle-input {
  width: 160px;
  display: inline-block;
}

.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}

.mr10 {
  margin-right: 10px;
}

#parent {
  text-align: center;
}
</style>